var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoomla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F9AE41;}\r\n\t.st1{fill:#EE4035;}\r\n\t.st2{fill:#4F91CD;}\r\n\t.st3{fill:#7AC043;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.3,7.2c0-3.5-2.9-6.4-6.4-6.4c-3.2,0-5.9,2.4-6.4,5.5c0,0-0.1,0-0.1,0c-5.2-2.4-9.7,1.8-9.7,1.8L15.1,19.8 l4.6,4.4l9.4-9.2c4.4-4.4,6.8-1.4,6.8-1.4c3.3,2.8,0.1,6.1,0.1,6.1l4.7,4.6c3.9-4.2,4.1-7.8,2.9-10.7C46.9,13.2,49.3,10.5,49.3,7.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.8,36.7C43.8,36.7,43.8,36.7,43.8,36.7C46.2,31.4,42,27,42,27L30.2,15.3l-4.4,4.6l9.2,9.4 c4.4,4.4,1.4,6.8,1.4,6.8c-2.8,3.3-6.1,0.1-6.1,0.1L25.8,41c4.2,3.9,7.8,4.1,10.7,2.9c0.4,3.2,3.1,5.6,6.4,5.6 c3.5,0,6.4-2.9,6.4-6.4C49.3,39.8,46.9,37.2,43.8,36.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.3,25.8L20.9,35c-4.4,4.4-6.8,1.4-6.8,1.4c-3.3-2.8-0.1-6.1-0.1-6.1l-4.7-4.6C5.4,30,5.2,33.6,6.4,36.5 c-3.2,0.4-5.6,3.1-5.6,6.4c0,3.5,2.9,6.4,6.4,6.4c3.2,0,5.9-2.4,6.4-5.5c0,0,0.1,0,0.1,0c5.2,2.4,9.7-1.8,9.7-1.8L35,30.2 L30.3,25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.1,20.7c-4.4-4.4-1.4-6.8-1.4-6.8c2.8-3.3,6.1-0.1,6.1-0.1l4.6-4.7C20.1,5.2,16.5,5,13.6,6.2 C13.2,3,10.5,0.6,7.2,0.6C3.7,0.6,0.8,3.5,0.8,7c0,3.2,2.4,5.9,5.5,6.4c0,0,0,0.1,0,0.1c-2.4,5.2,1.8,9.7,1.8,9.7l11.7,11.7 l4.4-4.6L15.1,20.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoomla);
export default __webpack_public_path__ + "static/media/joomla.5d87af55191a52e6df11c71603c44168.svg";
export { ForwardRef as ReactComponent };